<template>
  <div id="btnAddProductVersion">
    <v-menu
      v-model="menu"
      offset-x
      min-width="500px"
      close-on-click
      :close-on-content-click="false"
      attach="#btnAddProductVersion"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          :disabled="disabled"
          v-on="on"
        >
          Додати Версію
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <CustomTextField
                v-model="version"
                label="Версія"
                class="mx-1"
              />
            </v-col>
            <v-col cols="6">
              <DatePicker
                v-model="releaseDate"
                default-value
                label="Дата релізу"
                class="mx-1"
                :filled="false"
              />
            </v-col>
          </v-row>

          <v-row class="mb-1">
            <v-col cols="12">
              <UrlifyText
                v-model="notes"
                label="Опис оновлення"
                class="mx-1"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            text
            :disabled="!version || !releaseDate"
            @click="ok"
          >
            OK
          </v-btn>
          <v-btn
            text
            @click="cancel"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import DatePicker from "@/components/story/DatePicker";
import UrlifyText from "../../../components/UrlifyText";

export default {
  components: {
    DatePicker,
    UrlifyText,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    menu: false,
    releaseDate: null,
    version: "",
    notes: "",
  }),
  methods: {
    ok() {
      this.$emit("addVersion", {
        version: this.version,
        releaseDate: this.releaseDate,
        notes: this.notes,
      });
      this.cancel();
    },
    cancel() {
      this.releaseDate = null;
      this.notes = "";
      this.version = null;
      this.menu = false;
    },
  },
};
</script>
